import { Product } from "./catalog";

export const localProducts: Product[] = [
  {
    "id": "rosca-chocolate",
    "name": "Rosca de Chocolate",
    "description": "Deliciosa rosca de chocolate esponjosa y saborizada.",
    "prices": [
      {
        "people": "10-12 personas",
        "price": 22
      }
    ],
    "category": "roscas",
    "emoji": "🍫",
    "image": "/rocas/Copia de ROSCA DE CHOCOLATE ESTEFSCAKES.png"
  },
  {
    "id": "rosca-vainilla",
    "name": "Rosca de Vainilla",
    "description": "Suave rosca de vainilla con textura esponjosa y deliciosa.",
    "prices": [
      {
        "people": "10-12 personas",
        "price": 20
      }
    ],
    "category": "roscas",
    "emoji": "🍦",
    "image": "/rocas/Copia de ROSCA DE VAINILLA ESTEFSCAKES.png"
  },
  {
    "id": "rosca-zanahoria",
    "name": "Rosca de Zanahoria",
    "description": "Rica rosca de zanahoria con nueces y frosting de queso crema.",
    "prices": [
      {
        "people": "10-12 personas",
        "price": 22
      }
    ],
    "category": "roscas",
    "emoji": "🥕",
    "image": "/rocas/Copia de ROSCA DE ZANAHORIA.jpg"
  },
  {
    "id": "red-velvet",
    "name": "Red Velvet",
    "description": "Suave bizcocho de textura aterciopelada con cacao premium y vainilla. Rellena y cubierta con frosting de queso crema.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 24
      },
      {
        "people": "14-15 personas",
        "price": 46
      },
      {
        "people": "20-22 personas",
        "price": 66
      }
    ],
    "category": "clasicas",
    "emoji": "❤️",
    "image": "/clasicas/Red Velvet.jpg"
  },
  {
    "id": "torta-pina",
    "name": "Torta de Piña",
    "description": "Esponjoso ponqué de piña cubierto de almíbar de piña y guindas rojas.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 23
      },
      {
        "people": "12-14 personas",
        "price": 37
      },
      {
        "people": "22-25 personas",
        "price": 56
      }
    ],
    "category": "clasicas",
    "emoji": "🍍",
    "image": "/clasicas/torta de piña(1).jpg"
  },
  {
    "id": "torta-zanahoria",
    "name": "Torta de Zanahoria",
    "description": "Torta de zanahoria con nueces y pasas, rellena en capas con delicioso frosting de queso crema y nueces.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 48
      },
      {
        "people": "20-22 personas",
        "price": 68
      }
    ],
    "category": "clasicas",
    "emoji": "🥕",
    "image": "/clasicas/torta de Zanahoria.jpg"
  },
  {
    "id": "tres-leche",
    "name": "Tres Leches",
    "description": "Bizcocho de vainilla humedecido con las tres leches. Decorado con merengue suizo y un toque de canela.",
    "prices": [
      {
        "people": "4-5 personas",
        "price": 18
      },
      {
        "people": "14-15 personas",
        "price": 45
      }
    ],
    "category": "clasicas",
    "emoji": "🥛",
    "image": "/frias/Copia de TRES LECHE ESTEFSCAKES.png"
  },
  {
    "id": "torta-arequipe",
    "name": "Torta de Arequipe",
    "description": "Esponjoso ponqué de vainilla rellena de arequipe, cubierto de arequipe con lluvias de chocolate.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 24
      },
      {
        "people": "15-16 personas",
        "price": 36
      },
      {
        "people": "20-22 personas",
        "price": 55
      }
    ],
    "category": "clasicas",
    "emoji": "🍯",
    "image": "/clasicas/tortadearequipe.jpeg"
  },
  {
    "id": "marmoleada",
    "name": "Marmoleada",
    "description": "Esponjoso ponqué marmoleado, relleno y cubierto en capas de fudge de chocolate.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 43
      },
      {
        "people": "20-22 personas",
        "price": 57
      }
    ],
    "category": "clasicas",
    "emoji": "🌀",
    "image": "/clasicas/Torta marmoleada.jpg"
  },
  {
    "id": "selva-negra",
    "name": "Torta Selva Negra",
    "description": "Capas de bizcocho de chocolate húmedo, rellenas con crema chantilly, mermelada de cerezas y trozos de chocolate.",
    "prices": [
      {
        "people": "6-7 personas",
        "price": 27
      },
      {
        "people": "14-15 personas",
        "price": 55
      }
    ],
    "category": "clasicas",
    "emoji": "🍒",
    "image": "/choco/selva negra.jpg"
  },
  {
    "id": "quesillo",
    "name": "Quesillo",
    "description": "Delicioso postre de vainilla tradicional.",
    "prices": [
      {
        "people": "8-10 personas",
        "price": 16
      }
    ],
    "category": "clasicas",
    "emoji": "🍮",
    "image": "/clasicas/Copia de QUESILLO ESTEFSCAKES.png"
  },
  {
    "id": "fria-fresas",
    "name": "Fría de Fresas",
    "description": "Bizcochos humedecidos, relleno de crema pastelera y fresas, cubierto de crema Chantilly y fresas.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 52
      }
    ],
    "category": "frias",
    "emoji": "🍓",
    "image": "/frias/friadefresa.jpeg"
  },
  {
    "id": "fria-frutas",
    "name": "Fría de Frutas",
    "description": "Bizcochos humedecidos, relleno de crema pastelera y fresas, cubierto de crema Chantilly y fresas.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 52
      }
    ],
    "category": "frias",
    "emoji": "🍑",
    "image": "/frias/Copia de FRIA DE FRUTAS ESTEFSCAKES.png"
  },
  {
    "id": "fria-melocoton",
    "name": "Fría de Melocotón",
    "description": "Bizcocho de vainilla húmedo, relleno de crema pastelera y melocotón, cubierto de crema Chantilly y melocotón.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 52
      }
    ],
    "category": "frias",
    "emoji": "🍑",
    "image": "/frias/friademelocoton.jpeg"
  },
  {
    "id": "fria-cafe",
    "name": "Fría de Café",
    "description": "Bizcochos de chocolate y vainilla humedecidos con licor y café expresso, rellena de crema y gotas de chocolate, forrada con crema de café.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 46
      },
      {
        "people": "28-30 personas",
        "price": 68
      }
    ],
    "category": "frias",
    "emoji": "☕",
    "image": "/frias/Fria de cafe.jpg"
  },
  {
    "id": "fria-parchita",
    "name": "Fría de Parchita",
    "description": "Torta fría ligeramente humedecida, rellena de mousse de parchita, cubierta de crema Chantilly y sirope de parchita.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 24
      },
      {
        "people": "14-15 personas",
        "price": 38
      }
    ],
    "category": "frias",
    "emoji": "🟡",
    "image": "/frias/friadeparchita.jpeg"
  },
  {
    "id": "fria-almendras",
    "name": "Fría de Almendras",
    "description": "Bizcocho de almendras humedecido, relleno de crema de almendras, trozos de caramelo y almendras. Cubierto de crema de almendras.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 48
      }
    ],
    "category": "frias",
    "emoji": "🌰",
    "image": "/frias/Torta ria de almendras.jpg"
  },
  {
    "id": "cookies-creams",
    "name": "Cookies and Creams",
    "description": "Ponqué de vainilla humedecido, relleno de chantilly de Oreos, gotas de chocolate y trozos de Oreos, cubierto de chantilly de Oreos y ganache de chocolate.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 26
      },
      {
        "people": "14-15 personas",
        "price": 38
      },
      {
        "people": "20-22 personas",
        "price": 55
      }
    ],
    "category": "frias",
    "emoji": "🍪",
    "image": "/frias/Torta Cookies and creams.jpg"
  },
  {
    "id": "tres-leche-melocoton",
    "name": "Tres Leches Melocotón",
    "description": "Bizcocho de vainilla humedecido con las tres leches, relleno de crema pastelera y trozos de melocotones, cubierto de chantilly y melocotones.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 48
      }
    ],
    "category": "frias",
    "emoji": "🥛",
    "image": "/frias/Copia de TRES LECHE DE MELOCOTON ESTEFSCAKES.png"
  },
  {
    "id": "torta-snickers",
    "name": "Torta Snickers",
    "description": "Torta de chocolate humedecida, rellena en capas con cremosa combinación de snickers, cubierta de fudge de chocolate y trocitios de snickers.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 28
      },
      {
        "people": "14-15 personas",
        "price": 56
      }
    ],
    "category": "choco",
    "emoji": "🍬",
    "image": "/choco/Copia de TORTA SNICKERS ESTEFSCAKES.png"
  },
  {
    "id": "fudge-fresas",
    "name": "Torta Fudge de Fresas",
    "description": "Torta de chocolate humedecida, rellena con fudge de chocolate y fresas, cubierta con ganache de chocolate y fresas.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 49
      }
    ],
    "category": "choco",
    "emoji": "🍓",
    "image": "/choco/fudgedefresa.jpeg"
  },
  {
    "id": "fudge-chocolate",
    "name": "Fudge de Chocolate",
    "description": "Torta de chocolate ligeramente humedecida, rellena y forrada con cremoso fudge de chocolate.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 39
      },
      {
        "people": "20-22 personas",
        "price": 64
      }
    ],
    "category": "choco",
    "emoji": "🍫",
    "image": "/choco/chocofudge.jpeg"
  },
  {
    "id": "brookie-cake",
    "name": "Brookie Cake",
    "description": "Torta de chocolate humedecida, rellena con fudge de chocolate y trozos de galleta Brookie, cubierta de vainilla, drip de chocolate y trozos de Brookie con Nutella.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 23
      },
      {
        "people": "14-15 personas",
        "price": 43
      },
      {
        "people": "20-23 personas",
        "price": 65
      }
    ],
    "category": "choco",
    "emoji": "🍪",
    "image": "/choco/Torta brookie cake.jpg"
  },
  {
    "id": "choco-parchita",
    "name": "Chocoparchita",
    "description": "Torta húmeda de chocolate rellena en capas de mousse de parchita y fudge de chocolate.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 38
      }
    ],
    "category": "choco",
    "emoji": "🟡",
    "image": "/choco/Torta chocoparchita.jpg"
  },
  {
    "id": "brownie",
    "name": "Brownie",
    "description": "Húmedo por dentro y cronchi por fuera con topping de nutella, oreos y mym.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 18
      },
      {
        "people": "14-15 personas",
        "price": 32
      }
    ],
    "category": "brownies",
    "emoji": "🍫",
    "image": "/brownies/brownie.jpeg"
  },
  {
    "id": "brookie",
    "name": "Brookie",
    "description": "La combinación perfecta de un delicioso brownie con nuestra galleta chocochips.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 16
      },
      {
        "people": "14-15 personas",
        "price": 30
      }
    ],
    "category": "brownies",
    "emoji": "🍪",
    "image": "/minis/brookiegrande.jpg"
  },
  {
    "id": "pie-limon",
    "name": "Pie de Limón",
    "description": "Tartaleta a base de galleta, con mezcla cremosa sabor a limón decorado con merengue suizo.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 20
      },
      {
        "people": "14-15 personas",
        "price": 32
      }
    ],
    "category": "postres",
    "emoji": "🍋",
    "image": "/frias/Copia de PIE DE LIMON ESTEFSCAKES.png"
  },
  {
    "id": "gelato-chocoarequipe",
    "name": "Gelato Chocoarequipe",
    "description": "Cremosa torta helado a base de una crujiente galleta y una crema especial chocoarequipe.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 48
      }
    ],
    "category": "postres",
    "emoji": "🍨",
    "image": "/postres/Gelato.png"
  },
  {
    "id": "pie-parchita",
    "name": "Pie de Parchita",
    "description": "Tartaleta a base de galleta, con mezcla cremosa sabor a parchita decorado con merengue suizo.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 21
      },
      {
        "people": "14-15 personas",
        "price": 30
      }
    ],
    "category": "postres",
    "emoji": "🟡",
    "image": "/postres/piedeparchita.jpeg"
  },
  {
    "id": "cheesecake-oreo",
    "name": "Cheesecake de Oreo",
    "description": "Cheesecake de helado con galletas oreos americana, con base de galletas.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 25
      },
      {
        "people": "14-15 personas",
        "price": 46
      }
    ],
    "category": "cheesecakes",
    "emoji": "🍪",
    "image": "/cheesecakes/Cheescakes de oreos.jpg"
  },
  {
    "id": "cheesecake-fresas",
    "name": "Cheesecake de Fresas",
    "description": "Cheesecake horneado, con base de galleta, cubierto con frosting y trozos de fresas.",
    "prices": [
      {
        "people": "5-6 personas",
        "price": 28
      },
      {
        "people": "14-15 personas",
        "price": 55
      }
    ],
    "category": "cheesecakes",
    "emoji": "🍓",
    "image": "/cheesecakes/Chesscake de fresa.jpg"
  },
  {
    "id": "galletas-chocochips",
    "name": "Galletas Chocochips",
    "description": "Galletas suaves por dentro y cronchi por fuera de vainilla con trozos y gotas de chocolate.",
    "prices": [
      {
        "people": "12 unidades (30gr c/u)",
        "price": 13
      }
    ],
    "category": "minis",
    "emoji": "🍪",
    "image": "/minis/Copia de GALLETA CHOCOCHIPS ESTEFSCAKES.png"
  },
  {
    "id": "galletas-redvelvet",
    "name": "Galletas Red Velvet",
    "description": "Galletas suaves por dentro y cronchi por fuera tercio pelo de chocolate con gotas de chocolate.",
    "prices": [
      {
        "people": "12 unidades (30gr c/u)",
        "price": 12
      }
    ],
    "category": "minis",
    "emoji": "❤️",
    "image": "/minis/Copia de GALLETA RED VELVET ESTEFSCAKES.png"
  },
  {
    "id": "galletas-chocochoco",
    "name": "Galletas Chocochoco",
    "description": "Galletas suaves por dentro y cronchi por fuera de chocolate con gotas de chocolate.",
    "prices": [
      {
        "people": "12 unidades (30gr c/u)",
        "price": 13
      }
    ],
    "category": "minis",
    "emoji": "🍫",
    "image": "/minis/chocococo.jpg"
  },
  {
    "id": "mini-galletas-surtidas",
    "name": "Mini Galletas Surtidas",
    "description": "Variedad de mini galletas surtidas en diferentes sabores.",
    "prices": [
      {
        "people": "12 unidades",
        "price": 7
      }
    ],
    "category": "minis",
    "emoji": "🍪",
    "image": "/minis/surtidas.JPG"
  },
  {
    "id": "mini-brookies",
    "name": "Mini Brookies",
    "description": "La combinación perfecta de un delicioso brownie con nuestra galleta chocochips.",
    "prices": [
      {
        "people": "10 minis",
        "price": 13
      },
      {
        "people": "30 minis",
        "price": 32
      }
    ],
    "category": "minis",
    "emoji": "🍪",
    "image": "/minis/minibrookies.jpeg"
  },
  {
    "id": "mini-brownies",
    "name": "Mini Brownies",
    "description": "Brownie con topping de nutella.",
    "prices": [
      {
        "people": "12 minis",
        "price": 12
      },
      {
        "people": "30 minis",
        "price": 32
      }
    ],
    "category": "minis",
    "emoji": "🍫",
    "image": "/minis/Mini brownie.jpg"
  },
  {
    "id": "mini-dollies",
    "name": "Mini Dollies",
    "description": "Dulce a base de galletas y leche condensada con trozos de nueces y chocolate.",
    "prices": [
      {
        "people": "15 minis",
        "price": 15
      }
    ],
    "category": "minis",
    "emoji": "🤎",
    "image": "/minis/Copia de DOLLIES ESTEFSCAKES.png"
  },
  {
    "id": "trufas",
    "name": "Trufas de Chocolate",
    "description": "Trufas de chocolate con topping de lluvias de chocolate.",
    "prices": [
      {
        "people": "24 minis",
        "price": 19
      }
    ],
    "category": "minis",
    "emoji": "🍫",
    "image": "/minis/Trufas de chocolate.jpg"
  },
  {
    "id": "cupcakes",
    "name": "Cupcakes",
    "description": "Cupcakes decorados con buttercream colorido.",
    "prices": [
      {
        "people": "6 cupcakes",
        "price": 8
      },
      {
        "people": "24 cupcakes",
        "price": 18
      }
    ],
    "category": "minis",
    "emoji": "🧁",
    "image": "/minis/cupcakes.jpg"
  },
  {
    "id": "alfajores",
    "name": "Alfajores",
    "description": "Alfajores clásicos rellenos de arequipe.",
    "prices": [
      {
        "people": "24 minis",
        "price": 18
      },
      {
        "people": "40 minis",
        "price": 30
      }
    ],
    "category": "minis",
    "emoji": "🍪",
    "image": "/minis/Mini Alfajores.jpg"
  },
  {
    "id": "shots-tres-leche",
    "name": "Shots Tres Leche",
    "description": "Mini porciones del clásico tres leches.",
    "prices": [
      {
        "people": "12 shots",
        "price": 16
      },
      {
        "people": "35 shots",
        "price": 38
      }
    ],
    "category": "minis",
    "emoji": "🥛",
    "image": "/minis/Shots de tres lehce.png"
  },
  {
    "id": "mini-pie-limon",
    "name": "Mini Pie de Limón",
    "description": "Tartaleta de limón decorado con merengue.",
    "prices": [
      {
        "people": "24 minis",
        "price": 19
      },
      {
        "people": "36 minis",
        "price": 29
      }
    ],
    "category": "minis",
    "emoji": "🍋",
    "image": "/minis/Copia de Mini tartaletas de limon.jpg"
  },
  {
    "id": "tartaletas-fresa",
    "name": "Tartaletas Fría de Fresa",
    "description": "Rellenas de crema y decoradas con fresas.",
    "prices": [
      {
        "people": "24 minis",
        "price": 18
      },
      {
        "people": "36 minis",
        "price": 28
      }
    ],
    "category": "minis",
    "emoji": "🍓",
    "image": "/minis/Copia de TARTALETA DE FRESAS CREMA PASTELERA ESTEFSCAKES.png"
  },
  {
    "id": "mini-pie-parchita",
    "name": "Mini Pie de Parchita",
    "description": "Tartaleta con mezcla de parchita.",
    "prices": [
      {
        "people": "24 minis",
        "price": 18
      },
      {
        "people": "36 minis",
        "price": 29
      }
    ],
    "category": "minis",
    "emoji": "🟡",
    "image": "/minis/Copia de Mini tartaletas de pie de parchita.png"
  },
  {
    "id": "shots-fudge-chocolate",
    "name": "Shots Fudge Chocolate",
    "description": "Shots rellenos de fudge de chocolate.",
    "prices": [
      {
        "people": "12 shots",
        "price": 18
      },
      {
        "people": "35 shots",
        "price": 48
      }
    ],
    "category": "minis",
    "emoji": "🍫",
    "image": "/minis/Copia de Shots de chocofudge.jpg"
  },
  {
    "id": "shots-cheesecake-oreo",
    "name": "Shots Cheesecake de Oreo",
    "description": "Shots de cheesecake con galletas oreo.",
    "prices": [
      {
        "people": "12 shots",
        "price": 21
      },
      {
        "people": "35 shots",
        "price": 54
      }
    ],
    "category": "minis",
    "emoji": "🍪",
    "image": "/minis/Copia de shots de cheescakes de oreos.png"
  },
  {
    "id": "mini-shots-cafe",
    "name": "Mini Shots de Café",
    "description": "Shots sabor a café.",
    "prices": [
      {
        "people": "12 shots",
        "price": 18
      },
      {
        "people": "35 shots",
        "price": 46
      }
    ],
    "category": "minis",
    "emoji": "☕",
    "image": "/minis/Copia de Shots de torta de cafe.jpg"
  },
  {
    "id": "shots-limon",
    "name": "Shots de Limón",
    "description": "Shots cremosos de limón.",
    "prices": [
      {
        "people": "12 shots",
        "price": 19
      },
      {
        "people": "35 shots",
        "price": 45
      }
    ],
    "category": "minis",
    "emoji": "🍋",
    "image": "/minis/Shots de limon.JPG"
  },
  {
    "id": "shots-mousse-parchita",
    "name": "Shots Mousse Parchita",
    "description": "Shots de mousse de parchita.",
    "prices": [
      {
        "people": "12 shots",
        "price": 18
      },
      {
        "people": "35 shots",
        "price": 48
      }
    ],
    "category": "minis",
    "emoji": "🟡",
    "image": "/minis/Shots Mousse Parchita.JPG"
  },
  {
    "id": "shots-fresa-crema",
    "name": "Shots Fría de Fresa",
    "description": "Shots de fresa con crema.",
    "prices": [
      {
        "people": "12 shots",
        "price": 16
      },
      {
        "people": "35 shots",
        "price": 44
      }
    ],
    "category": "minis",
    "emoji": "🍧",
    "image": "/minis/Copia de shots de fresa.jpg"
  },
  {
    "id": "mini-cupcakes",
    "name": "Mini Cupcakes",
    "description": "Mini cupcakes decorados.",
    "prices": [
      {
        "people": "6 unidades",
        "price": 5
      },
      {
        "people": "24 unidades",
        "price": 17
      }
    ],
    "category": "minis",
    "emoji": "🧁",
    "image": "/minis/Mini Cupcakes.jpg"
  }
];
